module.exports = __webpack_public_path__ + "static/media/member nalas-13.4e308175.png";